/*
 *
 * AgendaDetail constants
 *
 */

export const FLUSH_STATE = "app/AgendaDetail/FLUSH_STATE";

export const LOAD_COURSE = "app/AgendaDetail/LOAD_COURSE";
export const LOAD_COURSE_SUCCESS = "app/AgendaDetail/LOAD_COURSE_SUCCESS";
export const LOAD_COURSE_ERROR = "app/AgendaDetail/LOAD_COURSE_ERROR";

export const UPDATE_COURSE = "app/AgendaDetail/UPDATE_COURSE";
export const UPDATE_COURSE_SUCCESS = "app/AgendaDetail/UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_ERROR = "app/AgendaDetail/UPDATE_COURSE_ERROR";
